import React, { Component } from 'react';
import './table-of-contents.scss';
import { getImageSource } from '../../../utility/image-source';
import { ImageConstants, Constants } from '../../../constants/constants';
import SharedProfile from '../../../../shared-storage/profile';
import SharedStaticText from '../../../../shared-storage/static-text-store';
import ExamPrepKitApi from '../../../apis/exam-prep-kit';
import ExamPrepKitV2Api from '../../../apis/exam-prep-kit-v2';
import AsyncStore from '../../../../shared-storage/async-store';
import Loading from '../../common/loading/loading';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
// import BrowseChapterList from '../../home-component/chapter-list/chapter-list';
import Path from '../../routes/routes-path';
import PDFViewer from '../pdf-viewer/pdf-viewer';
import CheatSheet from '../cheat-sheet/cheat-sheet';
import ThingsToRemember from '../things-to-remember/things-to-remember';
import ApproachToProblemSolving from '../exam-prep-kit/approach-to-problem-solving/approach-to-problem-solving';
import PrepKitSolvedExample from '../exam-prep-kit/prep-kit-solved-example/prep-kit-solved-example';
import CommonErrorExperience from '../exam-prep-kit/common-error-experience/common-error-experience';
import PrepKitTipsAndTricksExperience from '../exam-prep-kit/tips-and-trics-experience/tips-and-trics-experience';
import ExamPrepKitV2 from '../exam-prep-kit-v2';
import MyAssessments from '../../class-specific-flow/my-assessments/my-assessments';
import ConceptListV2 from '../../concept-list-v2/concept-list-v2';
import PracticeMoreExperience from '../exam-prep-kit/practice-more-experience/practice-more-experience';
import PrepareAndCaseStudy from '../prepare-and-case-study/prepare-and-case-study';


export default class TableOfContent extends Component {
    constructor(props) {
        super(props);
        // const { navigation } = this.props;
        // this.meta = navigation.getParam('meta');
        this.meta = this.props.metaInfo || {};
        console.log(this.meta)
        this.userInfo = SharedProfile.getProfile() || {};
        if (this.meta && this.meta.subjectId && !this.userInfo.subjectId) {
            this.userInfo.subjectId = this.meta.subjectId;
        } else if (!this.userInfo.subjectId) {
            this.userInfo.subjectId = Constants.MATHS_SUBJECTID;
        }
        // PrekitInstance.setPrepkitInstance(this)
        this.staticText = SharedStaticText.getStaticText('prepkitTableOfContents');

        // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()
        // this.props.navigation.addListener('didFocus', (data) => {
        this.getPrepKitTableOfContentProgress()
        this.fetchPdfKitActivity()  // NEW: fetch lock/completion state from pdf_kit_activity
        // });

        if (this.meta && this.meta.from && this.meta.from == 'CHAPTERS_LIST') {
            this.getUserTime()
        }
        this.state = {
            tableOfContent: [
                {
                    title: "Revise the Chapter",
                    icon: getImageSource(ImageConstants.CHEAT_SHEET_ICON),
                    percentage: 0,
                    type: "REVISE"
                },
                {
                    title: "Practice",
                    icon: getImageSource(ImageConstants.PRACTICE_QUESTION_ICON),
                    percentage: 0,
                    type: "PRACTICE"
                },
                {
                    title: "Prepare and Practice Case Study",
                    icon: getImageSource(ImageConstants.PRACTICE_QUESTION_ICON),
                    percentage: 0,
                    type: "PREPARE_AND_CASE_STUDY",
                    // Url: 'https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/9b9957ae-ba01-4368-bca6-f725a34570c6_Tractor%20Case%20Study.pdf'
                },
                {
                    title: "Cheat Sheet",
                    icon: getImageSource(ImageConstants.CHEAT_SHEET_ICON),
                    percentage: 0,
                    type: "CHEAT_SHEET",
                    Url: 'https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/2e255e9c-b7b0-46ae-bb68-2cb39468bdd0_Cheat%20sheet%20class%2010%20Real%20Number.improve.pdf'
                },
                {
                    title: "Things to remember",
                    icon: getImageSource(ImageConstants.THINGS_TO_REMEMBER_ICON),
                    percentage: 20,
                    type: "THINGS_TO_REMEMBER"
                },
                {
                    title: "Common Errors",
                    icon: getImageSource(ImageConstants.COMMON_ERRORS),
                    percentage: 50,
                    type: "COMMON_ERRORS",
                    Url: 'https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/17cd2454-6227-4cbe-a170-8e7a7881cfe1_CBSE_Class%20X_Ch%201%20Real%20Numbers_Common%20Errors.pdf'
                },
                {
                    title: "Tips and Tricks",
                    icon: getImageSource(ImageConstants.TIPS_AND_TRICKS_ICON),
                    percentage: 20,
                    type: "TIPS_AND_TRICKS",
                    Url: 'https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/ef1a4cd5-9d72-4579-8e8c-59e2119bb876_CBSE_Class%20X_Ch%201_%20Real%20Numbers_Tips%20and%20Tricks.pdf'
                }
            ],
            overallProgress: 0,
            loading: true,
            // --- Step-by-step unlock state (new) ---
            pdfKitActivity: null,        // fetched from pdf_kit_activity collection
            showLockedPopup: false,      // shown when a locked item is clicked
            lockedPopupMessage: ''       // message to show in the locked popup
        };

        if (!this.userInfo.isSubscribed) {

            // this.props.navigation.addListener("didFocus", () => {
            //     AppState.addEventListener('change', this._handleAppStateChange);
            // });

            // this.props.navigation.addListener("didBlur", () => {
            //     AppState.removeEventListener('change', this._handleAppStateChange);
            // });

        }

    }

    _handleAppStateChange = (state) => {

        // if (state == constants.APP_STATE_ACTIVE) {
        //     this.getUserTime()
        // } else if ((state == constants.APP_STATE_BACKGROUND && Platform.OS == 'android') || (state == constants.APP_STATE_IN_ACTIVE && Platform.OS == 'ios')) {
        //     this.stopTimer()
        //     clearInterval(this.timerInterval)
        // }\
    }

    // ─── Step-by-step unlock methods (new — do not modify existing methods) ───

    /**
     * Fetches the pdf_kit_activity document for this chapter.
     * The backend auto-creates it with all sections at { isCompleted: false, percentage: 0 }
     * if it doesn't exist yet (upsert-with-defaults on first TOC visit).
     */
    fetchPdfKitActivity = () => {
        const chapterKey = this.meta.chapterKey || this.meta.key;
        if (!chapterKey) return;
        ExamPrepKitV2Api.getPdfKitActivity({ chapterKey })
            .then(res => {
                const data = (res && res.data !== undefined) ? res.data : res;
                const sectionMap = {
                    REVISE: 'revise', LEARN_CONCEPTS: 'revise',
                    PRACTICE: 'practice', PRACTICE_QUESTIONS: 'practice',
                    PREPARE_AND_CASE_STUDY: 'prepareAndCaseStudy',
                    CHEAT_SHEET: 'cheatSheet',
                    THINGS_TO_REMEMBER: 'thingsToRemember',
                    COMMON_ERRORS: 'commonErrors',
                    TIPS_AND_TRICKS: 'tipsAndTricks'
                };
                let completedCount = 0;
                let lastCompletedPercentage = 0;
                const updatedTOC = (this.state.tableOfContent || []).map(item => {
                    const sKey = sectionMap[item.type];
                    const isCompleted = Boolean(data?.[sKey]?.isCompleted);
                    if (isCompleted) {
                        completedCount++;
                        const p = Number(data?.[sKey]?.percentage);
                        if (p > 0) {
                            lastCompletedPercentage = p;
                        }
                    }
                    return {
                        ...item,
                        isLocked: this.getLockedStatus(item.type, data),
                        isCompleted: isCompleted,
                        percentage: isCompleted ? 100 : item.percentage
                    };
                });
                const overallProgress = completedCount === 0
                    ? 0
                    : (completedCount === updatedTOC.length
                        ? 100
                        : (lastCompletedPercentage || Math.round((completedCount / updatedTOC.length) * 100)));
                this.setState({ pdfKitActivity: data || null, tableOfContent: updatedTOC, overallProgress });
            })
            .catch(err => {
                console.error('[TOC] fetchPdfKitActivity error:', err);
            });
    }

    /**
     * Returns true if the given TOC item type should be locked,
     * based on whether the previous item's isCompleted flag is true.
     * Revise (first item) is always unlocked.
     */
    getLockedStatus = (type, pdfKitActivity) => {
        if (type === 'REVISE' || type === 'LEARN_CONCEPTS') return false; // always unlocked
        if (!pdfKitActivity) return true; // default locked until doc is fetched
        const { revise, practice, prepareAndCaseStudy,
            cheatSheet, thingsToRemember, commonErrors } = pdfKitActivity;
        switch (type) {
            case 'PRACTICE':
            case 'PRACTICE_QUESTIONS': return !revise?.isCompleted;
            case 'PREPARE_AND_CASE_STUDY': return !practice?.isCompleted;
            case 'CHEAT_SHEET': return !prepareAndCaseStudy?.isCompleted;
            case 'THINGS_TO_REMEMBER': return !cheatSheet?.isCompleted;
            case 'COMMON_ERRORS': return !thingsToRemember?.isCompleted;
            case 'TIPS_AND_TRICKS': return !commonErrors?.isCompleted;
            default: return false;
        }
    }

    /**
     * Maps a TOC item type to the title of the item that must be
     * completed before it, for use in the locked-click popup message.
     */
    getPreviousItemTitle = (type) => {
        const prevTitleMap = {
            PRACTICE: 'Revise',
            PRACTICE_QUESTIONS: 'Revise',
            PREPARE_AND_CASE_STUDY: 'Practice',
            CHEAT_SHEET: 'Prepare and Case Study',
            THINGS_TO_REMEMBER: 'Cheat Sheet',
            COMMON_ERRORS: 'Things to Remember',
            TIPS_AND_TRICKS: 'Common Errors'
        };
        return prevTitleMap[type] || 'the previous activity';
    }

    /** Shows the popup when a student clicks a locked TOC item. */
    showLockedItemPopup = (message) => {
        this.setState({ showLockedPopup: true, lockedPopupMessage: message });
    }

    /** Hides the locked-item popup. */
    hideLockedItemPopup = () => {
        this.setState({ showLockedPopup: false, lockedPopupMessage: '' });
    }



    pauseTimer = () => {
        if (this.timerInterval) {
            this.stopTimer()
            clearInterval(this.timerInterval)
        }
    }

    resumeTimer = () => {
        this.getUserTime()

    }

    stopTimer = (type) => {

        // console.log(type,this.tick)

        let payload = {
            time: this.tick
        }

        ExamPrepKitApi.updateUserPrepkitTime(payload, (err, res) => {
            if (err) {
                return
            }

        })

    }

    getRemainingTime = () => {

        if (this.userInfo.isSubscribed) {
            return
        }

        if (this.landingScreenInstance) {

            this.remainingTime = this.landingScreenInstance.getRemainingAppTime()

            if (this.remainingTime > this.allowedPrepkitTime) {
                return 0
            }

            return this.remainingTime ? Math.ceil(this.remainingTime / 60) : 0
        }

        return 0
    }


    onClickLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu', { meta: { from: 'PREPKIT' } })
    }

    getUserTime = () => {

        let payload = {}

        // ExamPrepKitApi.getUserPrepkitTime(payload, (err, res) => {
        //     if (err) {
        //         return
        //     }
        //     console.log(res.prepkitTime, "******")

        //     this.setState({ timeRes: res })

        //     this.tick = res.prepkitTime.time
        //     this.trialUser = res.noAccessToPrepKit

        //     this.allowedPrepkitTime = res.prepkitAllowedTime

        //     let allowedTime = res.prepkitAllowedTime

        //     if (this.trialUser && this.tick == 0) {
        //         this.showTimerPopup()
        //         return
        //     }
        //     if (this.trialUser && this.tick >= allowedTime) {
        //         this.showTimeExhausted()
        //         // this.setState({showSubscriptionPage:true})
        //     } else {
        //         this.StartTimer(this.tick, allowedTime, res)
        //     }

        // })
    }

    showTimeExhausted = async () => {

        let doc = await AsyncStore.getExamPrepkitLimitInfo()

        if (doc) {
            doc = JSON.parse(doc)

            if (!doc[`${this.userInfo.mobileNumber}_${this.userInfo.userName}_PREPKIT_TIME_LIMIT`]) {

                doc[`${this.userInfo.mobileNumber}_${this.userInfo.userName}_PREPKIT_TIME_LIMIT`] = true

                AsyncStore.setExamPrepkitLimitInfo(doc)

                this.showTimeExhaustedPopup()
            } else {
                this.setState({ showSubscriptionPage: true })
            }
        } else {
            AsyncStore.setExamPrepkitLimitInfo({ [`${this.userInfo.mobileNumber}_${this.userInfo.userName}_PREPKIT_TIME_LIMIT`]: true })
            this.showTimeExhaustedPopup()
        }


    }

    StartTimer = (tick, allowedTime, timeRes) => {


        if (this.timerInterval) {
            clearInterval(this.timerInterval)
        }
        this.timerInterval = setInterval(() => {

            // if (this.trialUser && LandingScreen && LandingScreen.showTimeLimitPopUp()) {
            //     this.stopTimer()
            //     clearInterval(this.timerInterval)
            //     return
            // }
            if (this.trialUser && this.tick == timeRes.showPrepkitWarningMessageTime) {
                this.setState({ showToaster: true })
            }

            if (this.trialUser && this.tick >= allowedTime) {
                // FireBaseEvent.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_EXHAUSTED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
                // Facebook.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_EXHAUSTED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
                // BranchIO.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_EXHAUSTED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
                // moengage.logCustomEvent('Exam Pre Kit', { 'User Id': this.userInfo.userId, 'Trial Initiated': 'Yes', 'Trial Exhausted': 'Yes' })

                this.showTimeExhaustedPopup()
                this.stopTimer()
                clearInterval(this.timerInterval)
            } else {
                this.tick = this.tick + 1
            }

        }, 1000)
    }

    showTimerPopup = () => {


        this.setState({ showTimerPopup: true })
    }

    showTimeExhaustedPopup = () => {
        this.setState({ showTimerPopup: true, timeExhausted: true })
    }

    hideTimeExhaustedPopup = () => {
        this.setState({ showTimerPopup: false }, () => {

            // if (Platform.OS == 'ios') {
            //     setTimeout(() => {
            //         this.setState({ showSubscriptionPage: true })
            //     }, 500);
            // } else {
            //     this.setState({ showSubscriptionPage: true })
            // }

        })
    }

    hideTimerPopup = () => {

        // FireBaseEvent.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_INITIATED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
        // Facebook.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_INITIATED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
        // BranchIO.logCustomEvent(FirebaseEvents.EXAM_PREP_KIT_TRIAL_INITIATED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
        // moengage.logCustomEvent('Exam Pre Kit', { 'User Id': this.userInfo.userId, 'Trial Initiated': 'Yes', 'Trial Exhausted': 'No' })


        this.setState({ showTimerPopup: false }, () => {
            this.StartTimer(this.tick, this.state.timeRes.prepkitAllowedTime, this.state.timeRes)
        })
    }

    hideToaster = () => {
        this.setState({ showToaster: false })
    }

    showToaster = () => {
        this.setState({ showToaster: true })
    }

    hideSubscriptionPopUp = (noNavigate) => {

        if (this.showSubscriptionToaster)
            this.showSubscriptionToaster = false

        this.setState({ showSubscriptionPage: false }, () => {
            this.props.navigation.navigate('PrepKitChapterList', { meta: { title: "Circles" } });
        })
    }


    onPressAction = (item) => {

        if (item.disabled || item.isLocked || item.locked) {
            // NEW: show a helpful popup when a locked item is tapped
            if (item.isLocked || item.locked) {
                const prevTitle = this.getPreviousItemTitle(item.type);
                this.showLockedItemPopup(`Complete "${prevTitle}" first to unlock this section.`);
            }
            return;
        }

        if (item.type == 'REVISE' || item.type == 'LEARN_CONCEPTS') {
            this.showRevise({
                key: this.meta.chapterKey || this.meta.key,
                title: this.meta.chapterTitle || this.meta.title,
                categoryId: this.meta.categoryThemeId,
                chapterImage: this.meta.imageUrl,
                masterDataId: this.meta.masterDataId,
                conceptCardPdf: this.meta.conceptCardPdf,
                from: 'EXAM_PREP_KIT_V2',
                calledFrom: 'EXAM_PREP_KIT_V2'
            }, 0);
        }

        if (item.type == 'CHEAT_SHEET') {
            // this.openPdf(item.Url)
            this.showCheatSheet({ title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId })
            // this.props.navigation.navigate("CheatSheet", { meta: { title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId } })
        }

        if (item.type == 'THINGS_TO_REMEMBER') {
            this.showThingsToRemember({ title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId })
            // this.props.navigation.navigate("ThingsToRemember", { meta: { title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId } })
        }

        if (item.type == 'APPROACH_TO_PROBLEM_SOLVING') {
            this.showApprochToProblemSolving({ title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId })
            // this.props.navigation.navigate("ApproachToProblemSolving", { meta: { title: this.meta.chapterTitle, chapterKey: this.meta.chapterKey, categoryThemeId: this.meta.categoryThemeId } })
        }

        if (item.type == 'PRACTICE' || item.type == 'PRACTICE_QUESTIONS') {
            this.goToPractice()
        }

        if (item.type == 'PREPARE_AND_CASE_STUDY') {
            this.showPrepareAndCaseStudy({
                title: this.meta.chapterTitle || this.meta.title || 'Prepare and Case Study',
                chapterTitle: this.meta.chapterTitle || this.meta.title || 'Chapter',
                chapterKey: this.meta.chapterKey || this.meta.key,
                categoryId: this.meta.categoryThemeId,
                categoryThemeId: this.meta.categoryThemeId,
                chapterImage: this.meta.imageUrl,
                masterDataId: this.meta.masterDataId,
                conceptCardPdf: this.meta.conceptCardPdf,
                caseStudyUrl: this.meta.caseStudyUrl,
                Url: this.meta.caseStudyUrl,
                isCompleted: item.isCompleted,
                from: 'EXAM_PREP_KIT_V2',
                calledFrom: 'EXAM_PREP_KIT_V2'
            });
        }

        if (item.type == 'COMMON_ERRORS') {
            // this.openPdf(item.Url)
            this.showCommonErrorExperience({
                title: this.meta.chapterTitle,
                chapterKey: this.meta.chapterKey,
                headerIcon: getImageSource(ImageConstants.COMMON_ERRORS),
                categoryThemeId: this.meta.categoryThemeId,
                resumeIndex: this.progressResponse && this.progressResponse.commonErrorResumeId && item.percentage != 100 ? this.progressResponse.commonErrorResumeId : 0,
                isCommonErrorCompleted: item.percentage == 100 ? true : false
            })
            // this.props.navigation.navigate("CommonErrorExperience", {
            //     meta: {
            //         title: this.meta.chapterTitle,
            //         chapterKey: this.meta.chapterKey,
            //         headerIcon: getImageSource(ImageConstants.COMMON_ERRORS),
            //         categoryThemeId: this.meta.categoryThemeId,
            //         resumeIndex: this.progressResponse && this.progressResponse.commonErrorResumeId && item.percentage != 100 ? this.progressResponse.commonErrorResumeId : 0,
            //         isCommonErrorCompleted: item.percentage == 100 ? true : false
            //     }
            // })
        }

        if (item.type == 'SOLVED_EXAMPLES') {
            this.showPrepKitSolvedExample({
                title: this.meta.chapterTitle,
                chapterKey: this.meta.chapterKey,
                headerIcon: getImageSource(ImageConstants.SOLVED_EXAMPLES_ICON),
                categoryThemeId: this.meta.categoryThemeId,
                resumeIndex: this.progressResponse && this.progressResponse.solvedExampleResumeId && item.percentage != 100 ? this.progressResponse.solvedExampleResumeId : 0,
                isSolvedExampleCompleted: item.percentage == 100 ? true : false
            })
            // this.props.navigation.navigate("PrepKitSolvedExample", {
            //     meta: {
            //         title: this.meta.chapterTitle,
            //         chapterKey: this.meta.chapterKey,
            //         headerIcon: getImageSource(ImageConstants.COMMON_ERRORS),
            //         categoryThemeId: this.meta.categoryThemeId,
            //         resumeIndex: this.progressResponse && this.progressResponse.solvedExampleResumeId && item.percentage != 100 ? this.progressResponse.solvedExampleResumeId : 0,
            //         isSolvedExampleCompleted: item.percentage == 100 ? true : false
            //     }
            // })
        }

        if (item.type == 'TIPS_AND_TRICKS') {
            // this.openPdf(item.Url)
            this.showTipsAndTricksExperience({
                title: this.meta.chapterTitle,
                chapterKey: this.meta.chapterKey,
                headerIcon: getImageSource(ImageConstants.TIPS_AND_TRICKS_ICON),
                categoryThemeId: this.meta.categoryThemeId,
                resumeIndex: this.progressResponse && this.progressResponse.tipsAndTricksResumeId && item.percentage != 100 ? this.progressResponse.tipsAndTricksResumeId : 0,
                isTipsAndTricsCompleted: item.percentage == 100 ? true : false
            })
            // this.props.navigation.navigate("TipsAndTricsExperience", {
            //     meta: {
            //         title: this.meta.chapterTitle,
            //         chapterKey: this.meta.chapterKey,
            //         headerIcon: getImageSource(ImageConstants.TIPS_AND_TRICKS),
            //         categoryThemeId: this.meta.categoryThemeId,
            //         resumeIndex: this.progressResponse && this.progressResponse.tipsAndTricksResumeId && item.percentage != 100 ? this.progressResponse.tipsAndTricksResumeId : 0,
            //         isTipsAndTricsCompleted: item.percentage == 100 ? true : false
            //     }
            // })
        }

        if (item.type == 'MOCK_TEST') {
            // this.props.navigation.navigate('StartAssessment', { meta: { chapterKey: this.meta.chapterKey, chapterTitle: this.meta.chapterTitle, categoryThemeId: this.meta.categoryThemeId, isExamPrepKit: true } })
            this.goToMockTest()
        }
    }

    onClickChapter = (chapter, index, logEvent) => {
        console.log(chapter)

        let categoryThemeId = chapter.categoryId

        if (chapter.isFinished) {
            // moengage.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": CommonUtils.getCategoryTitle(categoryThemeId), "Completed in Class": CommonUtils.getBooleanValue(true), "Chapter Status": 'Completed' })
            // FireBaseEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": chapter.title, "Chapter Category": CommonUtils.getCategoryTitle(categoryThemeId), "Completed in Class": CommonUtils.getBooleanValue(true), "Chapter Status": 'Completed' })
            // Facebook.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted), "Chapter Status": 'Completed' })
            // BranchIO.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted), "Chapter Status": 'Completed' })
        }
        else if (!logEvent) {
            // moengage.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, 'Chapter Name': title, "Chapter Status": 'In Progress', "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted) })
            // FireBaseEvent('Chapter', { "User Id": this.userInfo.userId, 'Chapter Name': chapter.title, "Chapter Status": 'In Progress', "Chapter Category": CommonUtils.getCategoryTitle(categoryThemeId), "Completed in Class": CommonUtils.getBooleanValue(true) })
            // Facebook.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, 'Chapter Name': title, "Chapter Status": 'In Progress', "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted) })
            // BranchIO.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, 'Chapter Name': title, "Chapter Status": 'In Progress', "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted) })
        } else {
            // moengage.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted), "Chapter Status": 'Start' })
            // FireBaseEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": chapter.title, "Chapter Category": CommonUtils.getCategoryTitle(categoryThemeId), "Completed in Class": CommonUtils.getBooleanValue(true), "Chapter Status": 'Start' })
            // Facebook.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted), "Chapter Status": 'Start' })
            // BranchIO.logCustomEvent('Chapter', { "User Id": this.userInfo.userId, "Chapter Name": title, "Chapter Category": getCategoryTitle(categoryThemeId), "Completed in Class": getBooleanValue(isChapterNotCompleted), "Chapter Status": 'Start' })
        }

        let subjectId = this.meta?.subjectId || this.userInfo?.subjectId || Constants.MATHS_SUBJECTID;
        if (this.userInfo && !this.userInfo.subjectId) {
            this.userInfo.subjectId = subjectId;
        }

        let eloListMeta = {
            chapterKey: chapter.key,
            title: chapter.title,
            isChapterNotCompleted: true,
            categoryThemeId: chapter.categoryId,
            masterDataId: this.state.masterDataId,
            lockedForTrial: chapter.lockedForTrial,
            trialChapters: this.chaptersOpenForTrial,
            chapterImageUrl: chapter.chapterImage,
            conceptCardPdf: chapter.conceptCardPdf,
            subjectId: subjectId,
            calledFrom: 'EXAM_PREP_KIT_V2',
            from: 'EXAM_PREP_KIT_V2',
            selectedChapterIndex: index,
        }

        let history = this.props.history;
        let currentDelegate = this.props.delegate;
        while (!history && currentDelegate) {
            if (currentDelegate.props) {
                history = currentDelegate.props.history;
                currentDelegate = currentDelegate.props.delegate;
            } else {
                break;
            }
        }
        if (history) {
            history.push(Path.BROWSE_CHAPTER, { data: eloListMeta });
        }

        // this.setState({
        //     showEloList: true,
        //     selectedChapterIndex: index,
        //     eloListMeta: {
        //         chapterKey: chapter.key,
        //         title: chapter.title,
        //         isChapterNotCompleted: true,
        //         categoryThemeId: chapter.categoryId,
        //         masterDataId: this.state.masterDataId,
        //         lockedForTrial: chapter.lockedForTrial,
        //         trialChapters: this.chaptersOpenForTrial,
        //         chapterImageUrl: chapter.chapterImage
        //     }
        // })
        // this.props.navigation.navigate('EloList', { meta: { chapterKey: chapter.key, title: chapter.title, isChapterNotCompleted : true, categoryThemeId: chapter.categoryId, masterDataId: this.state.masterDataId, lockedForTrial: chapter.lockedForTrial, trialChapters: this.chaptersOpenForTrial } })
        // this.props.navigation.navigate('ChapterNavigation', { meta: { chapter: chapter } })
    }

    showRevise(chapter = {}, index = 0) {
        let subjectId = this.meta?.subjectId || this.userInfo?.subjectId || Constants.MATHS_SUBJECTID;
        if (this.userInfo && !this.userInfo.subjectId) {
            this.userInfo.subjectId = subjectId;
        }

        let eloListMeta = {
            chapterKey: chapter.key || this.meta.chapterKey || this.meta.key,
            title: chapter.title || this.meta.chapterTitle || this.meta.title,
            isChapterNotCompleted: true,
            categoryThemeId: chapter.categoryId || this.meta.categoryThemeId,
            masterDataId: this.state.masterDataId || this.meta.masterDataId,
            lockedForTrial: chapter.lockedForTrial,
            trialChapters: this.chaptersOpenForTrial,
            chapterImageUrl: chapter.chapterImage || this.meta.imageUrl,
            conceptCardPdf: chapter.conceptCardPdf || this.meta.conceptCardPdf,
            subjectId: subjectId,
            calledFrom: 'EXAM_PREP_KIT_V2',
            from: 'EXAM_PREP_KIT_V2',
            selectedChapterIndex: index,
        };
        this.setState({ showRevise: true, eloListMeta: eloListMeta });
    }

    hideRevise = () => {
        this.setState({ showRevise: false, eloListMeta: null }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({
                    chapterKey,
                    section: 'revise',
                    isCompleted: true
                }).then(() => {
                    this.fetchPdfKitActivity();
                }).catch(err => {
                    console.error('Error updating pdf kit activity for revise:', err);
                    this.fetchPdfKitActivity();
                });
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        });
    }

    showPrepareAndCaseStudy(data) {
        this.setState({ showPrepareAndCaseStudy: true, prepareAndCaseStudyMeta: data });
    }

    hidePrepareAndCaseStudy = () => {
        this.setState({ showPrepareAndCaseStudy: false, prepareAndCaseStudyMeta: null }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({
                    chapterKey,
                    section: 'prepareAndCaseStudy',
                    isCompleted: true
                }).then(() => {
                    this.fetchPdfKitActivity();
                }).catch(err => {
                    console.error('Error updating pdf kit activity for prepareAndCaseStudy:', err);
                    this.fetchPdfKitActivity();
                });
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        });
    }

    showThingsToRemember(data) {
        this.setState({ showThingsToRemember: true, ...data })
    }

    hideThingsToRemember() {
        this.setState({ showThingsToRemember: false }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({ chapterKey, section: 'thingsToRemember', isCompleted: true })
                    .then(() => this.fetchPdfKitActivity())
                    .catch(() => this.fetchPdfKitActivity());
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        })

    }

    showApprochToProblemSolving(data) {
        this.setState({ showApprochToProblemSolving: true, ...data })
    }

    hideApprochToProblemSolving() {
        this.setState({ showApprochToProblemSolving: false }, () => {
            this.getPrepKitTableOfContentProgress()
            this.fetchPdfKitActivity() // NEW: refresh lock/completion state
        })
    }

    showPrepKitSolvedExample(data) {
        this.setState({ showPrepKitSolvedExample: true, ...data })
    }

    hidePrepKitSolvedExample() {
        this.setState({ showPrepKitSolvedExample: false }, () => {
            this.getPrepKitTableOfContentProgress()
            this.fetchPdfKitActivity() // NEW: refresh lock/completion state
        })
    }

    showCommonErrorExperience(data) {
        this.setState({ showCommonErrorExperience: true, ...data })
    }

    hideCommonErrorExperience() {
        this.setState({ showCommonErrorExperience: false }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({ chapterKey, section: 'commonErrors', isCompleted: true })
                    .then(() => this.fetchPdfKitActivity())
                    .catch(() => this.fetchPdfKitActivity());
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        })
    }

    showTipsAndTricksExperience(data) {
        this.setState({ showTipsAndTricksExperience: true, ...data })
    }

    hideTipsAndTricksExperience() {
        this.setState({ showTipsAndTricksExperience: false }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({ chapterKey, section: 'tipsAndTricks', isCompleted: true })
                    .then(() => this.fetchPdfKitActivity())
                    .catch(() => this.fetchPdfKitActivity());
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        })
    }

    hidePracticeMoreExperience(isCompleted = false) {
        this.setState({ showPracticeMoreExperience: false }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            // Only mark practice completed in pdf_kit_activity when the student actually finished it.
            // PracticeMoreExperience passes isCompleted=true only when practiceButtonStatus === 'COMPLETED'.
            if (isCompleted && chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({
                    chapterKey,
                    section: 'practice',
                    isCompleted: true
                }).then(() => {
                    this.fetchPdfKitActivity();
                }).catch(err => {
                    console.error('Error updating pdf kit activity for practice:', err);
                    this.fetchPdfKitActivity();
                });
            } else {
                // Student navigated away without completing — just refresh lock state
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        })
    }

    showCheatSheet(data) {
        this.setState({ showCheatSheet: true, ...data })
    }

    hideCheatSheet() {
        this.setState({ showCheatSheet: false }, () => {
            const chapterKey = this.meta.chapterKey || this.meta.key;
            if (chapterKey) {
                ExamPrepKitV2Api.updatePdfKitActivity({ chapterKey, section: 'cheatSheet', isCompleted: true })
                    .then(() => this.fetchPdfKitActivity())
                    .catch(() => this.fetchPdfKitActivity());
            } else {
                this.fetchPdfKitActivity();
            }
            this.getPrepKitTableOfContentProgress();
        })
    }


    goToMockTest() {
        let chapterInfo = {
            chapterKey: this.meta.chapterKey,
            chapterTitle: this.meta.chapterTitle,
            calledFrom: 'EXAM_PREP_KIT'
        }
        let history = this.props.history;
        let currentDelegate = this.props.delegate;
        while (!history && currentDelegate) {
            if (currentDelegate.props) {
                history = currentDelegate.props.history;
                currentDelegate = currentDelegate.props.delegate;
            } else {
                break;
            }
        }
        if (history) {
            history.push(Path.CLASS_SPECIFIC_ASSESSMENT, { data: chapterInfo });
        }
    }

    goToPractice() {
        this.setState({ showPracticeMoreExperience: true })
    }

    openPdf(url) {

        window.open(url)
        // window.open(eventCertificate.url, '_blank').focus();

        //this.setState({ showCertificate: true, eventCertificateDetail: eventCertificate, selectedIndex: index })
        // var a = document.createElement('A');
        // var filePath = eventCertificate.url;
        // a.href = filePath;
        // a.download = filePath.substr(filePath.lastIndexOf('/') + 1);
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);

    }

    goBack = () => {
        this.stopTimer()
        clearInterval(this.timerInterval)
        this.props.navigation.goBack();
    }

    toggleShadow = () => {
        this.setState({ showShadow: !this.state.showShadow })
    }

    getPrepKitTableOfContentProgress = () => {

        let payload = {
            chapterKey: this.meta.chapterKey
        }

        this.setState({ loading: true })
        ExamPrepKitApi.getPrepKitTableOfContentProgress(payload).then((response) => {
            this.progressResponse = response;
            if (response.overallPercentage) {
                this.state.overallProgress = response.overallPercentage
            }

            let tableOfContent = this.state.tableOfContent;
            let completedCount = 0;
            let lastCompletedPercentage = 0;

            for (let i = 0; i < tableOfContent.length; i++) {

                let item = tableOfContent[i]

                if (item.type == 'REVISE' || item.type == 'LEARN_CONCEPTS') {
                    item.percentage = response.learnConceptsPercentage || response.revisePercentage || response.conceptCardPercentage || 0;
                }

                if (item.type == 'CHEAT_SHEET') {
                    item.percentage = response.cheatSheetPercentage
                }

                if (item.type == 'COMMON_ERRORS') {
                    item.percentage = response.commonErrorsPercentage
                }

                if (item.type == 'SOLVED_EXAMPLES') {
                    item.percentage = response.solvedExamplesPercentage
                }

                if (item.type == 'MOCK_TEST') {
                    item.percentage = response.mockTestPercentage
                }

                if (item.type == 'PRACTICE' || item.type == 'PRACTICE_QUESTIONS') {
                    item.percentage = response.practiceQuestionsPercentage || 0
                }

                if (item.type == 'TIPS_AND_TRICKS') {
                    item.percentage = response.tipsAndTricsPercentage
                }

                if (item.type == 'THINGS_TO_REMEMBER') {
                    item.percentage = response.thingsToRememberPercentage
                }

                if (item.type == 'APPROACH_TO_PROBLEM_SOLVING') {
                    item.percentage = response.approachToProblemSolvingPerentage
                }

                // NEW: set lock and completion state from pdf_kit_activity doc
                const sectionMap = {
                    REVISE: 'revise', LEARN_CONCEPTS: 'revise',
                    PRACTICE: 'practice', PRACTICE_QUESTIONS: 'practice',
                    PREPARE_AND_CASE_STUDY: 'prepareAndCaseStudy',
                    CHEAT_SHEET: 'cheatSheet',
                    THINGS_TO_REMEMBER: 'thingsToRemember',
                    COMMON_ERRORS: 'commonErrors',
                    TIPS_AND_TRICKS: 'tipsAndTricks'
                };
                const pdfKitActivity = this.state.pdfKitActivity;
                item.isLocked = this.getLockedStatus(item.type, pdfKitActivity);
                item.isCompleted = pdfKitActivity?.[sectionMap[item.type]]?.isCompleted || false;
                if (item.isCompleted) {
                    item.percentage = 100;
                    completedCount++;
                    const p = Number(pdfKitActivity?.[sectionMap[item.type]]?.percentage);
                    if (p > 0) {
                        lastCompletedPercentage = p;
                    }
                }

            }

            const overallProgress = completedCount === 0
                ? 0
                : (completedCount === tableOfContent.length
                    ? 100
                    : (lastCompletedPercentage || Math.round((completedCount / tableOfContent.length) * 100)));
            this.setState({ tableOfContent, loading: false, overallProgress })
        }).catch(err => {
            console.log(err)
            if (err) {
                this.setState({ loading: false })
                return
            }

        })
    }



    renderTableOfContent = () => {

        let elements = []
        const sectionMap = {
            REVISE: 'revise', LEARN_CONCEPTS: 'revise',
            PRACTICE: 'practice', PRACTICE_QUESTIONS: 'practice',
            PREPARE_AND_CASE_STUDY: 'prepareAndCaseStudy',
            CHEAT_SHEET: 'cheatSheet',
            THINGS_TO_REMEMBER: 'thingsToRemember',
            COMMON_ERRORS: 'commonErrors',
            TIPS_AND_TRICKS: 'tipsAndTricks'
        };
        const pdfKitActivity = this.state.pdfKitActivity;

        for (let i = 0; i < this.state.tableOfContent.length; i++) {

            let item = this.state.tableOfContent[i];
            const sKey = sectionMap[item.type];
            const isLocked = item.locked || this.getLockedStatus(item.type, pdfKitActivity);
            const isCompleted = Boolean(pdfKitActivity?.[sKey]?.isCompleted || item.isCompleted);
            const itemWithStatus = { ...item, isLocked, isCompleted };

            elements.push(
                <div key={item.type || i} onClick={() => this.onPressAction(itemWithStatus)}
                    className='d-flex align-items-center justify-content-between chapter-card pl-0 pb-3 pt-3 cursor-pointer'>
                    <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center'>
                            <div className='mr-2'>
                                {
                                    item.icon ? <img className='chapter-icon' src={item.icon}></img> :
                                        <img className='chapter-icon' src={getImageSource(ImageConstants.CHAPTER_ICN)} />
                                }
                            </div>
                            <div>
                                <div className='table-of-content-title'>{item.title}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {isLocked ? (
                            <img className='lock-icon-size' src={getImageSource(ImageConstants.LOCK)} alt="locked" />
                        ) : isCompleted ? (
                            <button className="start-btn cursor-pointer">Revise</button>
                        ) : (
                            <button className="start-btn cursor-pointer">Start</button>
                        )}
                    </div>
                </div>
            )
        }

        return elements
    }

    goToHomeScreen() {
        this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
    }

    goToExamPrepKit() {
        this.hideContents();
        if (this.props.delegate && this.props.delegate.hideTableOfContents) {
            this.props.delegate.hideTableOfContents();
        }
    }

    goToPrepare() {
        this.hideSchoolAssessment();
        if (this.props.delegate && this.props.delegate.goBackToChapter) {
            this.props.delegate.goBackToChapter();
        } else if (this.props.delegate && this.props.delegate.goToPrepare) {
            this.props.delegate.goToPrepare();
        } else if (this.props.delegate && this.props.delegate.hideExamPrepKit) {
            this.props.delegate.hideExamPrepKit();
        }
    }

    hideMockTest = () => {
        this.hideSchoolAssessment();
    }

    goToTableOfContents = () => {
        this.hideSchoolAssessment();
    }

    goToExamPrepKitV2() {
        this.setState({ showExamPrepKitV2: true })
    }

    hideExamPrepKitV2() {
        this.setState({ showExamPrepKitV2: false })
    }

    goToSchoolAssessment(data) {
        this.setState({
            showExamPrepKitV2: false,
            showMyAssessment: true,
            schoolAssessmentMeta: data
        })
    }

    hideSchoolAssessment() {
        this.setState({ showMyAssessment: false, showExamPrepKitV2: true, schoolAssessmentMeta: null })
    }

    renderBreadcrumbForChapterList = () => {
        const chapterTitle = this.meta?.chapterTitle || this.meta?.title || 'Chapter';
        return (
            <div className='breadcrumb mt-2'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>Home</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className='title-1 chapter-title cursor-pointer' title={chapterTitle} onClick={() => this.goToPrepare()}>
                    {chapterTitle}
                </span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className='title-1 breadcrumb-nowrap cursor-pointer' onClick={() => this.goToExamPrepKit()}>Exam Prep Kit</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className='title-1 active breadcrumb-nowrap'>{`Table of Contents`}</span>
            </div>
        );
    }

    showPrepKitChapterList() {
        this.hideContents()
        this.props.showPrepKitChapterList && this.props.showPrepKitChapterList()
    }

    hideContents() {
        this.setState({
            showThingsToRemember: false,
            showApprochToProblemSolving: false,
            showPrepKitSolvedExample: false,
            showCommonErrorExperience: false,
            showTipsAndTricksExperience: false,
            showCheatSheet: false,
            showPrepareAndCaseStudy: false
        }, () => {
            this.getPrepKitTableOfContentProgress()
        });
    }

    render() {


        if (this.state.showCheatSheet) {
            return <CheatSheet delegate={this}
                metaInfo={{ title: this.state.title, chapterKey: this.meta.chapterKey, categoryThemeId: this.state.categoryThemeId }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showPrepareAndCaseStudy && this.state.prepareAndCaseStudyMeta) {
            return (
                <PrepareAndCaseStudy
                    delegate={this}
                    metaInfo={this.state.prepareAndCaseStudyMeta}
                    showPrepKitChapterList={() => this.showPrepKitChapterList()}
                    back={() => this.hidePrepareAndCaseStudy()}
                />
            );
        }

        if (this.state.showThingsToRemember) {
            return <ThingsToRemember delegate={this}
                metaInfo={{ title: this.state.title, chapterKey: this.meta.chapterKey, categoryThemeId: this.state.categoryThemeId }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showApprochToProblemSolving) {
            return <ApproachToProblemSolving delegate={this}
                metaInfo={{ title: this.state.title, chapterKey: this.meta.chapterKey, categoryThemeId: this.state.categoryThemeId }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showPrepKitSolvedExample) {
            return <PrepKitSolvedExample delegate={this}
                metaInfo={{
                    title: this.state.title,
                    chapterKey: this.meta.chapterKey,
                    headerIcon: this.state.headerIcon,
                    categoryThemeId: this.state.categoryThemeId,
                    resumeIndex: this.state.resumeIndex,
                    isSolvedExampleCompleted: this.state.isSolvedExampleCompleted
                }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showRevise && this.state.eloListMeta) {
            return (
                <ConceptListV2
                    delegate={this}
                    params={this.state.eloListMeta}
                    back={() => this.hideRevise()}
                />
            );
        }

        if (this.state.showCommonErrorExperience) {
            return <CommonErrorExperience delegate={this}
                metaInfo={{
                    title: this.state.title,
                    chapterKey: this.meta.chapterKey,
                    headerIcon: this.state.headerIcon,
                    categoryThemeId: this.state.categoryThemeId,
                    resumeIndex: this.state.resumeIndex,
                    isCommonErrorCompleted: this.state.isCommonErrorCompleted
                }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showTipsAndTricksExperience) {
            return <PrepKitTipsAndTricksExperience delegate={this}
                metaInfo={{
                    title: this.state.title,
                    chapterKey: this.meta.chapterKey,
                    headerIcon: this.state.headerIcon,
                    categoryThemeId: this.state.categoryThemeId,
                    resumeIndex: this.state.resumeIndex,
                    isTipsAndTricsCompleted: this.state.isTipsAndTricsCompleted
                }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showPracticeMoreExperience) {
            return <PracticeMoreExperience
                delegate={this}
                metaInfo={{
                    title: this.meta.chapterTitle,
                    chapterKey: this.meta.chapterKey,
                    headerIcon: this.state.headerIcon,
                    categoryThemeId: this.state.categoryThemeId,
                    baseLineAssessmentActivityId: this.meta.baseLineAssessmentActivityId
                }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }

        if (this.state.showMyAssessment && this.state.schoolAssessmentMeta) {
            return <MyAssessments delegate={this} meta={{ ...this.state.schoolAssessmentMeta, from: 'EXAM_PREP_KIT_V2' }} />;
        }

        if (this.state.showExamPrepKitV2) {
            return <ExamPrepKitV2 delegate={this}
                metaInfo={{
                    title: this.state.title,
                    chapterTitle: this.meta.chapterTitle,
                    chapterKey: this.meta.chapterKey,
                    headerIcon: this.state.headerIcon,
                    categoryThemeId: this.state.categoryThemeId,
                    caseStudyUrl : this.meta.caseStudyUrl,
                    resumeIndex: this.state.resumeIndex,
                    isTipsAndTricsCompleted: this.state.isTipsAndTricsCompleted
                }}
                showPrepKitChapterList={() => this.showPrepKitChapterList()} />
        }






        return (
            <>
                {
                    !this.state.loading ?
                        <div className='prep-kit-table-of-contents mb-5'>
                            <div className="text-right">
                                <img className="header-image-size" src={getImageSource(ImageConstants.HEADER_BG_IMAGE)}></img>
                            </div>
                            {
                                this.renderBreadcrumbForChapterList()
                            }
                            <div className='d-flex align-items-center '>
                                <div className='title'>{this.meta.chapterTitle}</div>
                                <div className='pl-3'>Prepare</div>
                            </div>
                            <div className='mt-2'>
                                <img className="divider-image-width" src={getImageSource(ImageConstants.TITLE_DIVIDER)}></img>
                            </div>
                            <div>
                                <div className='d-flex mt-3 align-items-center'>
                                    <div className='chapter-progress-bar'>
                                        <div className='chapter-inner-progress' style={{ width: `${this.state.overallProgress}%` }}>
                                        </div>
                                    </div>
                                    <div className='ml-2 progress-value'>{`${this.state.overallProgress}%`}</div>
                                </div>
                            </div>

                            <div className='mt-3'>{this.staticText.tableOfContentsText ? this.staticText.tableOfContentsText : "Table of Content"}</div>

                            <div className=''>
                                {this.renderTableOfContent()}
                            </div>

                            {(!this.meta || this.meta.from !== 'EXAM_PREP_KIT_V2') && (
                                <div onClick={() => this.goToExamPrepKitV2()} className="d-flex align-items-center justify-content-between chapter-card pl-0 pb-3 pt-3 cursor-pointer">
                                    <div className="d-flex align-items-center">
                                        <div className="mr-2">
                                            <img className="chapter-icon" src={getImageSource(ImageConstants.MOCK_TEST)} />
                                        </div>
                                        <div>
                                            <div className="table-of-content-title">Exam Prep Kit</div>
                                        </div>
                                    </div>
                                    <div>
                                        <img className="arrow-image-size" src={getImageSource(ImageConstants.BLUE_ARROW_ICON)} />
                                    </div>
                                </div>
                            )}

                            {/* <div className='notes-wrapper mt-4 mb-5'>
                                
                                <div>
                                    <div className='notes-text'>
                                        {this.staticText.noteText ? this.staticText.noteText : "You need to complete all the section to mark this step completed"}
                                    </div>
                                </div>
                            </div> */}

                        </div>

                        :
                        <Loading />
                }

                {/* {this.state.showTimerPopup && <Timerpopup delegate={this} timeExhausted={this.state.timeExhausted} appTime={this.getRemainingTime()} />}

                {this.state.showSubscriptionPage ? <SubscriptionPopUp
                    navigation={this.props.navigation}
                    showPopup={true} delegate={this}
                    nextDayStartsIn={this.state.nextDayStartsIn}
                    showTimer={this.state.showTimerInDailyLimit}
                    close={this.hideSubscriptionPopUp}
                    showHighlightedPlan={true}
                    meta={{ showBlur: this.state.showBlur, showToaster: this.showSubscriptionToaster }}
                /> : <></>
                }

                {this.state.showToaster ? <TimeToaster showModal={this.state.showToaster} delegate={this} /> : <></>} */}

                {/* NEW: locked-item popup — shown when student clicks a locked TOC item */}
                {this.state.showLockedPopup && (
                    <div className='toc-locked-overlay' onClick={this.hideLockedItemPopup}>
                        <div className='toc-locked-popup' onClick={e => e.stopPropagation()}>
                            <div className='toc-locked-popup-icon'>🔒</div>
                            <div className='toc-locked-popup-message'>{this.state.lockedPopupMessage}</div>
                            <button className='toc-locked-popup-btn' onClick={this.hideLockedItemPopup}>Got it</button>
                        </div>
                    </div>
                )}

            </>

        )
    }

}


